import * as angular from 'angular';

import { IDispatcherService, IDispatcher, IMailingJobActionsService } from '../';
import { MailingJobDefinitionDto } from '../../models';

export interface IMailingJobsStoreService {
    getOne: (guid: string) => angular.IPromise<MailingJobDefinitionDto>;
    getAll: (force?: boolean) => angular.IPromise<MailingJobDefinitionDto[]>;
}

export interface IMailingJobsActionDispatcherService extends IDispatcherService<IMailingJobsStoreService> { }

export class MailingJobsActionDispatcherService implements IMailingJobsActionDispatcherService {
    static serviceId = 'mailingJobsActionDispatcherService';

    static $inject = ['mailingJobActionsService'];

    constructor(private _actionService: IMailingJobActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IMailingJobsStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._actionService.getAll(force)),
                getOne: (guid: string) => dispatch(this._actionService.getOne(guid)),
            }
        };
    }
}